<template>
<!--  <div id="app">-->
<!--    <router-link to="/">Home</router-link> |-->
<!--    <router-link to="/about">About</router-link> |-->
<!--    <router-link to="/delays">Delays</router-link> |-->
<!--    <router-link to="/training">Training</router-link>-->
<!--  </div>-->
  <div id="app">

  </div>
  <router-view/>
</template>

<script>
import router from "@/router";
import {nextTick} from "vue";

export default {
  setup() {
    router.afterEach((to) => {
      nextTick(() => {
        document.title = to.meta.title || 'Janus-v1'
      })
    })
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #706C61;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
body {
  background-color: #706C61;
}
</style>
